function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "18",
  height: "17",
  viewBox: "0 0 18 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M17.97 6.355a.896.896 0 00-.773-.589l-5.114-.729L9.79.496A.9.9 0 008.982 0a.9.9 0 00-.809.496L5.881 5.028l-5.114.738a.894.894 0 00-.728.598.865.865 0 00.225.878l3.712 3.514-.899 4.99a.87.87 0 00.36.878.916.916 0 00.943.062l4.602-2.346 4.584 2.355c.126.07.268.105.413.105.19 0 .376-.058.53-.167a.87.87 0 00.36-.878l-.899-4.99 3.712-3.514a.867.867 0 00.288-.896z",
  fill: "currentColor",
  fillRule: "evenodd"
})));